import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProjectEditor from "./ProjectEditor"
import { changeField, initialize } from "../../modules/project/projectWriteSlice";

const ProjectEditorContainer = () => {
    const dispatch = useDispatch();
    const { title, body } = useSelector(({ projectWrite }) => ({
        title: projectWrite.title,
        body: projectWrite.body
    }));

    /**
     *  onChangeField를 useCallback으로 감싸주었는데, 이는 ProjectEditor 컴포넌트에서 사용할 useEffect에서 onChangeField를
     *  사용할 것이기 때문. onChangeField를 useCallback으로 감싸 주어야만 나중에 ProjectEditor에서 사용할 useEffect가
     *  컴포넌트가 화면에 나타났을 때 딱 한 번만 실행되기 때문이다.
     */

    const onChangeField = useCallback((payload) => {
        dispatch(changeField(payload));
    }, [dispatch]);

    // 언마운트될 때 초기화
    /**
     * 사용자가 WritePage에서 벗어날 때는 데이터를 초기화 해야 한다. 컴포넌트가 언마운트될 때 useEffect로 INITIALIZE
     * 액션을 발생시켜 리덕스의 write관련 상태를 초기화해 준다. 만약 초기화를 하지 않으면, 포스트 작성 후 다시 글쓰기
     * 페이지에 들어왔을 때 이전 작성한 내용이 남아있기 때문.
     */

    // 여기서하면 언마운트 되기전에도 초기화가 되어버린다. 여기서 삭제하고 수정/작성 성공시 수행하도록 WrteActionButtonsContainer에 갖다두자.
    // [해결. '24.1/8] <React.Strictmode>를 없애야 한다. 검증을 위해 두번 렌더링하기 때문에 동 문제가 생겼다.
    useEffect(() => {
        return () => {
            dispatch(initialize());
        };
    }, [dispatch]);
    

    return (
        <ProjectEditor onChangeField={onChangeField} title={title} body={body} />
    );
};

export default ProjectEditorContainer;